import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import queryparse from 'tricks/string/queryparse';
import useLocalStorage from 'hooks/useLocalStorage';
import PlaylistCompletionModal from './PlaylistCompletionModal';
var PlaylistCompletionContext = /*#__PURE__*/createContext(null);
var completedPlaylistsStorageKey = 'completed_playlists';
export function usePlaylistCompletionContext() {
  var context = useContext(PlaylistCompletionContext);
  if (context === null) {
    throw new Error("PlaylistCompletionContext must be inside PlaylistCompletionProvider");
  }
  return context;
}
function PlaylistCompletionProvider(_ref) {
  var _completedPlaylistsQu;
  var children = _ref.children;
  // get current url
  var location = useLocation();

  // store modal queue in local storage
  var _useLocalStorage = useLocalStorage(completedPlaylistsStorageKey, []),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    completedPlaylistsQueue = _useLocalStorage2[0],
    setCompletedPlaylistsQueue = _useLocalStorage2[1];
  // control whether modal (1st modal in modal queue) is shown
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    canShowModal = _useState2[0],
    setCanShowModal = _useState2[1];

  // read params and their values as an object from URL
  var _queryparse = queryparse(location.search),
    asset = _queryparse.asset;

  // trigger showing of completion modal upon change of asset param in url (eg when leaving assetViewer)
  // for cases in which shouldShowModalImmediately is set to false
  useEffect(function () {
    var timeOut = setTimeout(function () {
      setCanShowModal(true);
    }, 200);
    return function () {
      return clearTimeout(timeOut);
    };
  }, [asset]);
  if (!completedPlaylistsQueue) {
    return null;
  }
  function setCompletedPlaylists(_ref2) {
    var playlists = _ref2.playlists,
      initialPlaylistId = _ref2.initialPlaylistId,
      _ref2$shouldShowModal = _ref2.shouldShowModalImmediately,
      shouldShowModalImmediately = _ref2$shouldShowModal === void 0 ? true : _ref2$shouldShowModal;
    // Sort order of completion modals
    function compare(a, b) {
      // Show modal for current playlist first
      if (a.id === initialPlaylistId) {
        return -1;
      }
      if (b.id === initialPlaylistId) {
        return 1;
      }
      // show rest of modals sorted alphabetically by playlist name
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    }
    if (completedPlaylistsQueue) {
      // add newly completed playlists to queue
      var queue = completedPlaylistsQueue.concat(playlists);

      // Remove any duplicates
      var uniqueIds = new Set();
      var cleanQueue = queue.filter(function (playlist) {
        var isDuplicate = uniqueIds.has(playlist.id);
        uniqueIds.add(playlist.id);
        if (!isDuplicate) {
          return true;
        }
        return false;
      });
      cleanQueue.sort(compare);
      setCanShowModal(shouldShowModalImmediately);
      setCompletedPlaylistsQueue(cleanQueue);
    }
  }
  function handleClose() {
    if (completedPlaylistsQueue) {
      // update playlist queue and remove last viewed modal
      setCompletedPlaylistsQueue(completedPlaylistsQueue.slice(1));
    }
  }
  return /*#__PURE__*/React.createElement(PlaylistCompletionContext.Provider, {
    value: {
      setCompletedPlaylists: setCompletedPlaylists
    }
  }, children, canShowModal && completedPlaylistsQueue.length >= 1 && /*#__PURE__*/React.createElement(PlaylistCompletionModal, {
    key: (_completedPlaylistsQu = completedPlaylistsQueue[0]) === null || _completedPlaylistsQu === void 0 ? void 0 : _completedPlaylistsQu.id,
    playlist: completedPlaylistsQueue[0],
    onClose: handleClose
  }));
}
export default PlaylistCompletionProvider;